import {
  ChaosApi,
  ChaosApiChaosApiOrgsOidClustersCidGetRequest,
  ChaosApiChaosApiOrgsOidClustersCidExperimentsEidDeleteRequest,
  ChaosApiChaosApiDraftOrgsOidClustersCidPostRequest,
  ChaosApiFaultApiOrgsOidClustersCidGetRequest,
  ChaosApiFaultApiOrgsOidClustersCidPostRequest,
  ChaosApiFaultApiOrgsOidClustersCidDeleteRequest,
  ChaosApiChaosApiStartOrgsOidClustersCidExperimentsEidPostRequest,
  ChaosApiChaosApiOrgsOidClustersCidExperimentsEidGetRequest,
  ChaosApiChaosApiComponentsOrgsOidClustersCidGetRequest,
  ChaosApiChaosApiApproveOrgsOidClustersCidExperimentsEidPostRequest,
  ChaosApiChaosApiSummaryOrgsOidClustersCidExperimentsEidPostRequest
} from '@drill-test/client'

import { axiosInstance } from './base'

////////////

function getApiBasePath(): string {
  // may change to '/drill-test/api/v1' in the future
  return ''
}
const basePath = getApiBasePath()

////////////

const chaosApi = new ChaosApi(undefined, basePath, axiosInstance)

export function createChaosExperiment(
  params: ChaosApiChaosApiDraftOrgsOidClustersCidPostRequest
) {
  return chaosApi.chaosApiDraftOrgsOidClustersCidPost(params)
}

export function getChaosExperimentsList(
  params: ChaosApiChaosApiOrgsOidClustersCidGetRequest
) {
  return chaosApi.chaosApiOrgsOidClustersCidGet(params)
}

export function deleteChaosExperiment(
  params: ChaosApiChaosApiOrgsOidClustersCidExperimentsEidDeleteRequest
) {
  return chaosApi.chaosApiOrgsOidClustersCidExperimentsEidDelete(params)
}

export function getChaosExperimentDetail(
  params: ChaosApiChaosApiOrgsOidClustersCidExperimentsEidGetRequest
) {
  return chaosApi.chaosApiOrgsOidClustersCidExperimentsEidGet(params)
}

export function getDrillTestEnableStatus(
  params: ChaosApiFaultApiOrgsOidClustersCidGetRequest
) {
  return chaosApi.faultApiOrgsOidClustersCidGet(params)
}

export function enableDrillTest(
  params: ChaosApiFaultApiOrgsOidClustersCidPostRequest
) {
  return chaosApi.faultApiOrgsOidClustersCidPost(params)
}

export function disableDrillTest(
  params: ChaosApiFaultApiOrgsOidClustersCidDeleteRequest
) {
  return chaosApi.faultApiOrgsOidClustersCidDelete(params)
}

export function getExperimentActionsList() {
  return chaosApi.chaosApiActionsSchemaGet()
}

export function startChaosExperiment(
  params: ChaosApiChaosApiStartOrgsOidClustersCidExperimentsEidPostRequest
) {
  return chaosApi.chaosApiStartOrgsOidClustersCidExperimentsEidPost(params)
}

export function getComponentList(
  params: ChaosApiChaosApiComponentsOrgsOidClustersCidGetRequest
) {
  return chaosApi.chaosApiComponentsOrgsOidClustersCidGet(params)
}

export function approveExperiment(
  param: ChaosApiChaosApiApproveOrgsOidClustersCidExperimentsEidPostRequest
) {
  return chaosApi.chaosApiApproveOrgsOidClustersCidExperimentsEidPost(param)
}

export function updateExperimentInfo(
  param: ChaosApiChaosApiSummaryOrgsOidClustersCidExperimentsEidPostRequest
) {
  return chaosApi.chaosApiSummaryOrgsOidClustersCidExperimentsEidPost(param)
}

export function getChaosPermission() {
  return chaosApi.faultApiPingGet()
}
